import type { ContextState } from './context/types.tsx';
import type { EntitiesState } from './entities/types.tsx';
import type { State } from './types.tsx';
import type { UiState } from './ui/types.tsx';

export const contextSelector: (arg1: State) => ContextState = (state) => state.context;
export const entitiesSelector: (arg1: State) => EntitiesState = (state) => state.entities;
export const uiSelector: (arg1: State) => UiState = (state) => state.ui;
